import { render } from "./NewPasswordView.vue?vue&type=template&id=130018cd"
import script from "./NewPasswordView.vue?vue&type=script&lang=js"
export * from "./NewPasswordView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LENOVO\\Desktop\\Septem\\mobins.frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__